import CountUp from "react-countup";
import styles from "./overlay.module.scss"
import { useRef } from "react";
import { RENEW_DASH_COLOR, RENEW_DASH_DIR } from "../../constants/constants";

function Item({ name, x, y, power, dir, color, bgColor, offset }) {
	const tableRef = useRef(null);

	const table = {
		width: tableRef.current?.clientWidth,
		height: tableRef.current?.clientHeight
	}

	const img = {
		width: 10,
		height: 10
	}

	return (
		<div className={styles.overlay} style={{ left: x, top: y, background: bgColor }}>
			{/* <div style={{ position: 'absolute', color: 'red', top: '-20px' }}>{name}</div> */}
			<table ref={tableRef} style={{ color }}>
				<thead>
					<tr>
						<th>금일발전량</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<div>
								<img alt="" src="/images/renewStat/renewMap/power.svg" />
								<span>
									<CountUp end={power} decimals={1} separator="," duration={1.5} redraw={true}/>
									&nbsp;
									MWh
								</span>
							</div>
						</td>
					</tr>
				</tbody>
			</table>

			{tableRef.current && (
				<svg
					className={styles.tail}
					width={img.width}
					height={img.height}
					viewBox="0 0 10 10"
					xmlns="http://www.w3.org/2000/svg"				
					fill={bgColor}
					style={(() => {
						if (dir === RENEW_DASH_DIR.N) return {
							left: (table.width / 2) - img.width + offset,
							top: -img.height,
							transform: 'translateX(50%) rotate(0deg)',
						};
						if (dir === RENEW_DASH_DIR.E) return {
							left: table.width,
							top: (table.height / 2) - img.height + offset,
							transform: 'translateY(50%) rotate(90deg) ',
						};
						if (dir === RENEW_DASH_DIR.S) return {
							left: (table.width / 2) - img.width + offset,
							top: table.height,
							transform: 'translateX(50%) rotate(180deg)',
						};
						if (dir === RENEW_DASH_DIR.W) return {
							left: -img.width,
							top: (table.height / 2) - img.height + offset,
							transform: 'translateY(50%) rotate(270deg)',
						};
					})()}
				>
					<polygon points="5,0 10,10 0,10" />
				</svg>
			)}
		</div>
	)
}

export default function Overlay({ data, rgnCode }) {
  const locPerRgn = [
    { rgnCode: "44250", rgnTerm: "계룡시", x: 630, y: 490, dir: RENEW_DASH_DIR.S, offset: 0 },
    { rgnCode: "44710", rgnTerm: "금산군", x: 780, y: 750, dir: RENEW_DASH_DIR.N, offset: 0 },
    { rgnCode: "44150", rgnTerm: "공주시", x: 640, y: 380, dir: RENEW_DASH_DIR.W, offset: 0 },
    { rgnCode: "44230", rgnTerm: "논산시", x: 600, y: 700, dir: RENEW_DASH_DIR.N, offset: 0 },
    { rgnCode: "44270", rgnTerm: "당진시", x: 270, y: 40, dir: RENEW_DASH_DIR.S, offset: 0 },
    { rgnCode: "44180", rgnTerm: "보령시", x: 250, y: 540, dir: RENEW_DASH_DIR.N, offset: 0 },
    { rgnCode: "44760", rgnTerm: "부여군", x: 410, y: 650, dir: RENEW_DASH_DIR.N, offset: 0 },
    { rgnCode: "44210", rgnTerm: "서산시", x: 160, y: 130, dir: RENEW_DASH_DIR.S, offset: 0 },
    { rgnCode: "44770", rgnTerm: "서천군", x: 320, y: 760, dir: RENEW_DASH_DIR.N, offset: 0 },
    { rgnCode: "44200", rgnTerm: "아산시", x: 480, y: 110, dir: RENEW_DASH_DIR.S, offset: 0 },
    { rgnCode: "44810", rgnTerm: "예산군", x: 370, y: 310, dir: RENEW_DASH_DIR.N, offset: 0 },
    { rgnCode: "44130", rgnTerm: "천안시", x: 620, y: 80, dir: RENEW_DASH_DIR.S, offset: 0 },
    { rgnCode: "44790", rgnTerm: "청양군", x: 380, y: 500, dir: RENEW_DASH_DIR.N, offset: 0 },
    { rgnCode: "44825", rgnTerm: "태안군", x: 50, y: 260, dir: RENEW_DASH_DIR.N, offset: 0 },
    { rgnCode: "44800", rgnTerm: "홍성군", x: 240, y: 280, dir: RENEW_DASH_DIR.S, offset: 0 },
  ];

	return (
		<div className={styles.wrapper}>
			{data?.map((item) => {
				const curr = locPerRgn?.find((d) => d.rgnCode === item.rgnCode);
				return (
					<Item
						name={curr.rgnTerm}
						key={curr.rgnCode}
						x={curr.x}
						y={curr.y}
						power={(item?.dayPower ?? 0) + (item?.dayAddPower) ?? 0}
						dir={curr.dir}
						offset={curr.offset}
						{...(() => {
							if (item.cnt < 1000) return RENEW_DASH_COLOR[0];
							if (item.cnt < 3000) return RENEW_DASH_COLOR[1];
							if (item.cnt < 5000) return RENEW_DASH_COLOR[2];
							return RENEW_DASH_COLOR[3];
						})()}
						{...rgnCode === item.rgnCode && { bgColor: '#F56600' }}
					/>
				)
			})}
		</div>
	)
}